import React from 'react';

function Footer() {
  return (
    <footer style={{
      marginTop: '60px',
      padding: '20px 10px',
      backgroundColor: '#f1f1f1',
      textAlign: 'center',
      fontSize: '0.85rem',
      color: '#777',
      fontFamily: "'Nunito', sans-serif"
    }}>
      <p>© 2025 Share Your Kofi. All rights reserved.</p>
      <p>
        <strong>Disclaimer:</strong> Share Your Kofi is an independent project and is not affiliated with Ko-fi.com. All listings are unverified.
      </p>
      <p>
        <a
          href="https://ko-fi.com/emanoj"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#4dabf7', textDecoration: 'underline' }}
        >
          Support me on Ko-fi
        </a>
      </p>
           {/* Product Hunt Badge */}
           <div style={{ marginTop: '20px' }}>
        <a
          href="https://www.producthunt.com/products/share-your-kofi?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-share-your-kofi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Share Your Kofi - A beautifully simple directory for Ko‑fi creators. | Product Hunt"
            width="250"
            height="54"
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1060808&theme=light&t=1768092736949"
          />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
